export default __webpack_public_path__ + "static/ay-glossary-havent-found-gmail-3841b0bbca00ef17077892f082e81e7d.svg";